import React, { useState, useEffect } from 'react';
import '../../assets/style/eegisterProvider.css';
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import OTPInput, { ResendOTP } from 'otp-input-react';
import { useNavigate } from 'react-router-dom';
import Web3 from 'web3';
import { toast } from 'react-toastify';
import components from '../../components';
import ApiCall from '../../utils/Api';
import contractABI from '../../utils/contractABI';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
// insight
const RegisterProviderMain = () => {
  const [name, setName] = useState('');
  const [OTP, setOTP] = useState('');
  const contractAddress = import.meta.env.VITE_APP_contractAddress; // ✅ Main contract for registerProvider
  const [isconnected, setisconnected] = useState(false);
  const [signer, setSigner] = useState(null);
  const [txhash, setTxHash] = useState({});
  const [web3, setWeb3] = useState(null);
  const [contracts, setContract] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setshowConfirmPassword] = useState(false);
  const [WalletAddress, setWalletAddress] = useState('');
  const [loaderState, setloaderState] = useState();
  const [metaMaskError, setmetaMaskError] = useState('');
  const [ProviderState, setProviderState] = useState({
    email: '',
    Password: '',
    ConfirmPassword: '',
    code: '',
    walletAddress: '',
  });
  // const [ProviderState, setProviderState] = useState({
  //   email: 'sadici9488@adrewire.com',
  //   Password: 'check@1122',
  //   ConfirmPassword: 'check@1122',
  //   code: 'UVC',
  //   walletAddress: '',
  // });

  useEffect(() => {
    const initContract = async () => {
      try {
        // ✅ FIXED: Use main contract for registerProvider function
        const deployedContract = new web3.eth.Contract(
          contractABI,
          contractAddress
        );
        setContract(deployedContract);

        // localStorage.setItem(
        //   "deployedContract",
        //   JSON.stringify(deployedContract)
        // ); // Save web3 instance to local storage
      } catch (error) {
        console.log(error);
      }
    };

    if (web3) {
      initContract();
    }
  }, [web3]);

  // Check wallet connection status on page load
  useEffect(() => {
    const checkWalletStatus = async () => {
      try {
        if (!window.ethereum) {
          setisconnected(false);
          return;
        }

        // Check if MetaMask is available and unlocked
        const accounts = await window.ethereum.request({ method: 'eth_accounts' });
        
        if (accounts && accounts.length > 0) {
          // Check if wallet is truly unlocked by testing a simple call
          try {
            await window.ethereum.request({
              method: 'eth_getBalance',
              params: [accounts[0], 'latest']
            });
            // If successful, wallet is connected and unlocked
            setWalletAddress(accounts[0]);
            setisconnected(true);
            console.log('Wallet is connected and unlocked:', accounts[0]);
          } catch (balanceError) {
            // Wallet is locked
            console.log('MetaMask is locked:', balanceError.message);
            setisconnected(false);
            setWalletAddress('');
          }
        } else {
          // No accounts available
          setisconnected(false);
          setWalletAddress('');
        }
      } catch (error) {
        console.log('Error checking wallet status:', error);
        setisconnected(false);
        setWalletAddress('');
      }
    };

    checkWalletStatus();
  }, []);

  const initWeb3 = async () => {
    if (window.ethereum) {
      // Modern dapp browsers
      const web3Instance = new Web3(window.ethereum);
      try {
        // Request user approval to access their accounts
        await window.ethereum.enable();
        console.log('FLow one');
        setWeb3(web3Instance);
        console.log('Data inside ', web3);
        setisconnected(true);
        localStorage.setItem('web3Instance', JSON.stringify(web3Instance)); // Save web3 instance to local storage
      } catch (error) {
        console.error(error);
      }
    } else if (window.web3) {
      // Legacy dapp browsers
      const web3Instance = new Web3(window.web3.currentProvider);
      setWeb3(web3Instance);
    } else {
      // Non-dapp browsers
      console.log('Please install MetaMask!');
    }
  };

  // const navigate = useNavigate();
  const Navigate = useNavigate();
  const renderSeparator = (index) => {
    if (index === 3) {
      return <span>-</span>;
    }
    return null;
  };
  const inputStyle = {
    width: '2rem', // Adjust the width as needed
    height: '2rem', // Adjust the height as needed
    fontSize: '1.5rem', // Adjust the font size as needed
    border: '1px solid #ccc', // Add a border for the input fields
    borderRadius: '4px', // Add rounded corners
    margin: '0.25rem', // Add some margin between input fields
    textAlign: 'center', // Center the text within the input field
  };

  const handleChange = (event) => {
    setProviderState({
      ...ProviderState,
      [event.target.name]: event.target.value,
    });
  };
  const registerProvider = async () => {
    // console.log("Name is Rafay",contracts)
    setmetaMaskError('');
    if (!ProviderState.email) {
      toast.error('Email is required');
      return;
    } else if (!ProviderState.Password) {
      toast.error('Password is required');
      return;
    } else if (!ProviderState.ConfirmPassword) {
      toast.error('Confirm Password is required');
      return;
    } else if (ProviderState.ConfirmPassword !== ProviderState.Password) {
      toast.error('Password and Confirm Password do not match.');
      return;
    } else if (!ProviderState.code) {
      toast.error('Code is required');
      return;
    } else if (!name) {
      toast.error('Name is required');
      return;
    } else if (!WalletAddress) {
      toast.error('Wallet not connected');
      return;
    }
    try {
      console.log('YOu data');
      console.log(web3);
      setloaderState(true);
      const accounts = await web3.eth.getAccounts();
      console.log(
        '🚀 ~ file: registerProviderMain.js:532 ~ registerProvidernottttt ~ accounts:',
        accounts
      );
      const account = accounts[0];
      console.log(account);
      const result = await contracts.methods
        .registerProvider(name)
        .send({ from: account });
      setTxHash(result.transactionHash);
      setloaderState(false);

      if (result?.transactionHash) {
        try {
          console.log('🚀 ~ Smart contract transaction successful, calling backend API...');
          
          const data = await ApiCall.Api.post('/provider/registerProvider', {
            email: ProviderState.email,
            password: ProviderState.Password,
            institutionName: name,
            institutionCode: ProviderState.code,
            walletAddress: WalletAddress,
          });

          console.log('🚀 ~ Backend API response:', data);
          
          if (data.data && data.data.success) {
            setProviderState({});
            localStorage.setItem('userData', data.data.token || '');
            localStorage.setItem('role', 'Fund Provider');
            localStorage.setItem('name', name);
            localStorage.setItem('id', data.data.user?.id || '');
            
            toast.success(data.data.message || 'Registration successful!');
            
            // Skip OTP verification for now and go directly to login or profile
            // Navigate('/auth/varifyOTP');
            Navigate('/auth/Login');
          } else {
            toast.error(data.data?.message || 'Registration failed. Please try again.');
          }
        } catch (apiError) {
          console.error('🚀 ~ Backend API error:', apiError);
          if (apiError.code === 'ECONNREFUSED') {
            toast.error('Backend server is not running. Please start the backend server on port 5000');
          } else if (apiError.response) {
            toast.error(apiError.response.data?.message || 'Backend registration failed');
          } else {
            toast.error('Network error. Please check your connection.');
          }
        }
      } else {
        toast.error('Smart contract transaction failed. Please try again.');
      }

      // setShowModal(true);
    } catch (error) {
      setloaderState(false);
      console.log('error', error.message);
      if (error.response) {
        toast.error(error.response.data.message);
      } else if (
        error?.message?.includes('User denied transaction signature.')
      ) {
        toast.error('User denied transaction signature.');
      } else {
        setmetaMaskError(error.message);
      }
    }
  };

  const connectWallet = async () => {
    try {
      if (!window.ethereum) {
        toast.error('Please install MetaMask browser extension');
        return;
      }

      // Check if we're on HTTPS (required for MetaMask in production)
      if (location.protocol !== 'https:' && location.hostname !== 'localhost' && location.hostname !== '127.0.0.1') {
        toast.error('MetaMask requires HTTPS connection. Please use HTTPS for this site.');
        return;
      }

      // If already connected, disconnect
      if (isconnected) {
        try {
          await window.ethereum.request({
            method: 'wallet_revokePermissions',
            params: [{ eth_accounts: {} }]
          });
          setisconnected(false);
          setWalletAddress('');
          setWeb3(null);
          toast.success('Wallet disconnected successfully');
          return;
        } catch (disconnectError) {
          console.log('Disconnect error:', disconnectError);
          // Still disconnect locally even if revoke fails
          setisconnected(false);
          setWalletAddress('');
          setWeb3(null);
          toast.success('Wallet disconnected');
          return;
        }
      }

      const web3Instance = new Web3(window.ethereum);
      console.log('Sos', web3Instance);

      // Always request account access to ensure MetaMask opens
      console.log('Requesting MetaMask connection...');
      setWeb3(web3Instance);
      
      const accounts = await window.ethereum.request({
        method: 'eth_requestAccounts',
      });
      
      if (!accounts || accounts.length === 0) {
        toast.error('Please unlock your MetaMask wallet and try again');
        return;
      }
      
      setWalletAddress(accounts[0]);
      setisconnected(true);
      toast.success('You have connected with MetaMask successfully.');

      // 0x5009A12371F0719eC7Bf5cDD2036Cd6F4180c63F
      // 0x7E23c3FdD332E1954c7122D53ed6b78cE43eEc9e
    } catch (error) {
      console.log('Connect wallet error:', error);
      
      if (error?.code === 4001) {
        toast.error('Please unlock your MetaMask wallet and try again');
      } else if (error?.code === -32002) {
        toast.error('MetaMask connection request already pending. Please check your MetaMask extension.');
      } else if (error?.message?.includes('wallet_requestPermissions')) {
        toast.error('Request for account permission already pending');
      } else if (error?.message?.includes('User rejected')) {
        toast.error('Wallet connection was rejected');
      } else if (error?.message?.includes('User denied')) {
        toast.error('Wallet connection was denied');
      } else if (error?.message?.includes('Non-Error promise rejection')) {
        toast.error('MetaMask connection failed. Please refresh the page and try again.');
      } else if (error?.message?.includes('Already processing')) {
        toast.error('MetaMask is already processing a request. Please wait and try again.');
      } else {
        console.error('Wallet connection error:', error);
        toast.error(`Failed to connect wallet: ${error?.message || 'Unknown error'}`);
      }
    }
    if (window.web3) {
      // Legacy dapp browsers
      const web3Instance = new Web3(window.web3.currentProvider);
      setWeb3(web3Instance);
    }
  };
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: '10%',
        width: '100%',
        backgroundColor: '#F3F4F8',
      }}
    >
      <components.Loader.Back_Drop state={loaderState} />

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          width: '50%',
        }}
      >
        <span className='Loginheading'>Register Fund Provider</span>
        <div className='LoginScreen'>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: 100,
              justifyContent: 'space-evenly',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <span style={{ width: '90%', fontFamily: 'Manrope, sans-serif' }}>
                Institution Name
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <TextField
                onChange={(e) => {
                  setName(e.target.value);
                }}
                style={{ width: '90%' }}
                id='outlined-basic'
                label='Enter your Institution’s Name'
                variant='outlined'
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: 100,
              justifyContent: 'space-evenly',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <span style={{ width: '90%', fontFamily: 'Manrope, sans-serif' }}>
                Email
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <TextField
                onChange={(e) => {
                  handleChange(e);
                }}
                type='email'
                name='email'
                inputProps={{ autoComplete: 'chrome-off' }}
                value={ProviderState.email}
                style={{ width: '90%' }}
                id='outlined-basic'
                label='Enter your Email Address'
                variant='outlined'
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: 100,
              justifyContent: 'space-evenly',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <span style={{ width: '90%', fontFamily: 'Manrope, sans-serif' }}>
                Password
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <TextField
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        edge='end'
                        onClick={() => setShowPassword((prev) => !prev)}
                        aria-label='toggle password visibility'
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                inputProps={{ autoComplete: 'new-password' }}
                onChange={(e) => {
                  handleChange(e);
                }}
                type={showPassword ? 'text' : 'password'}
                name='Password'
                value={ProviderState.Password}
                style={{ width: '90%' }}
                id='outlined-basic'
                label='Enter your Password'
                variant='outlined'
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: 100,
              justifyContent: 'space-evenly',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <span style={{ width: '90%', fontFamily: 'Manrope, sans-serif' }}>
                Confirm Password
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <TextField
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        edge='end'
                        onClick={() => setshowConfirmPassword((prev) => !prev)}
                        aria-label='toggle password visibility'
                      >
                        {showConfirmPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  handleChange(e);
                }}
                type={showConfirmPassword ? 'text' : 'password'}
                name='ConfirmPassword'
                value={ProviderState.ConfirmPassword}
                style={{ width: '90%' }}
                id='outlined-basic'
                label='Please Confirm Your Password'
                variant='outlined'
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: 100,
              justifyContent: 'space-evenly',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <span style={{ width: '90%', fontFamily: 'Manrope, sans-serif' }}>
                Institution Code
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <TextField
                onChange={(e) => {
                  handleChange(e);
                }}
                style={{ width: '90%' }}
                name='code'
                value={ProviderState.code}
                id='outlined-basic'
                label='Enter 2-4 letter code to identify your institution'
                variant='outlined'
              />
              {/* <input placeholder='Enter Your Fund Provider Title' type='text' /> */}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: 100,
              justifyContent: 'space-evenly',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <span style={{ width: '90%', fontFamily: 'Manrope, sans-serif' }}>
                Connect Your Wallet
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
                width: '100%',
              }}
            >
              <Button onClick={connectWallet} variant='outlined'>
                {isconnected ? `Connected: ${WalletAddress?.slice(0, 6)}...${WalletAddress?.slice(-4)}` : 'Connect a wallet via Meta Mask'}
              </Button>
            </div>
          </div>
          {metaMaskError && (
            <div
              style={{
                // display: 'flex',
                width: '90%',
                alignSelf: 'center',
                paddingBottom: 20,
              }}
            >
              <p style={{ fontFamily: 'Manrope, sans-serif' }}>
                {'Error: '}
                <span style={{ color: '#ff000090' }}>{metaMaskError}</span>
              </p>
              {/* <Button
                variant='outlined'
                style={{}}
                onClick={() => setmetaMaskError('')}
              >
                Clear
              </Button> */}
            </div>
          )}
          <div
            style={{
              display: 'flex',
              width: '90%',
              alignSelf: 'center',
              justifyContent: 'flex-end',
              paddingBottom: 20,
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
              <Button
                variant='outlined'
                style={{ marginRight: 20 }}
                onClick={() => {
                  Navigate('/auth/Login');
                }}
              >
                {' '}
                Cancel
              </Button>
              <Button
                onClick={
                  registerProvider
                  // Navigate("/admin-panel/verifiedFundProvider")
                }
                variant='contained'
              >
                Register
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterProviderMain;
